/** Settings, Integrations tab: whether each sync last worked, refreshed every minute. */
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { IntegrationsList } from '../../components/settings/integrations-list';
import { integrationsQuery } from '../../lib/queries';
import { describeRpcError } from '../../lib/rpc';

export const Route = createFileRoute('/settings/integrations')({
  component: Integrations,
});

function Integrations() {
  const q = useQuery({ ...integrationsQuery(), refetchInterval: 60_000 });
  if (q.error) return <p className="text-body text-alert">{describeRpcError(q.error)}</p>;
  if (!q.data) return <p className="text-body text-ink-3">Loading</p>;
  return <IntegrationsList rows={q.data.rows} />;
}
